/*
 * Copyright (c) 2023. Vitalii Kozyr
 */

package core.domain.model

import kotlinx.serialization.Serializable

@Serializable
enum class Locale {
    UA
}